import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTheme } from '../../store/slices/appSlice';

const ThemeSelector = () => {
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.app.theme);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const themes = [
    { id: 'default', label: 'Default', icon: '🎨' },
    { id: 'japanese', label: 'Japan', icon: '🇯🇵' },
    { id: 'penguin', label: 'Penguin', icon: '🐧' },
  ];

  const currentTheme = themes.find((t) => t.id === theme) || themes[0];

  const handleThemeChange = (id) => {
    dispatch(setTheme(id));
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="inline-flex items-center justify-center sm:justify-between w-full rounded-md border border-gray-300 shadow-sm p-2 sm:px-3 sm:py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500"
        id="menu-button"
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <span className="flex items-center overflow-hidden">
          <span className="w-5 sm:w-6 flex justify-center sm:mr-2 flex-shrink-0">{currentTheme.icon}</span>
          <span className="truncate hidden sm:block">{currentTheme.label}</span>
        </span>
        <svg
          className="ml-2 h-5 w-5 flex-shrink-0 text-gray-400 hidden sm:block"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {isOpen && (
        <div
          className="origin-top-right absolute right-0 sm:left-0 sm:right-0 mt-2 w-32 sm:w-full rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-800 dark:ring-gray-700 z-50 overflow-hidden"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="menu-button"
          tabIndex="-1"
        >
          <div className="py-1" role="none">
            {themes.map((t) => (
              <button
                key={t.id}
                onClick={() => handleThemeChange(t.id)}
                className={`${
                  theme === t.id
                    ? 'bg-gray-100 text-gray-900 dark:bg-gray-700 dark:text-white'
                    : 'text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700'
                } group flex items-center w-full px-3 py-2 text-sm`}
                role="menuitem"
                tabIndex="-1"
              >
                <span className="w-6 flex justify-center mr-2 flex-shrink-0">{t.icon}</span>
                <span className="truncate">{t.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ThemeSelector;
